module.exports = __webpack_public_path__ + "img/section3-shadow-left.ec3c120f.png";